export default "/latin-ext.920711de-894736.woff2";